import React from 'react';

type DrawerSectionHeaderProps = {
  text: string;
  icon?: React.ReactNode;
};

export function DrawerSectionHeader({ text, icon }: DrawerSectionHeaderProps) {
  return (
    <div className="tw:flex tw:items-center tw:gap-2 tw:mb-2">
      {icon}
      <span className="tw:text-brand-green-0 tw:italic tw:text-sm">{text}</span>
    </div>
  );
}

type DrawerFieldProps = {
  label: string;
  value: React.ReactNode;
  whitespacePreLine?: boolean;
};

export function DrawerField({ label, value, whitespacePreLine }: DrawerFieldProps) {
  return (
    <>
      <div className="tw:text-zinc-400 tw:text-sm tw:ml-5.75">{label}:</div>
      <div className={`tw:text-zinc-700 ${whitespacePreLine ? 'tw:whitespace-pre-line' : ''}`}>
        {value || '--'}
      </div>
    </>
  );
}
